import styled from 'styled-components';
import { em } from 'polished';
import { Heading } from 'elements';
import { colors } from 'core/theme';
import { Flex, media } from 'core/layout';


export const FlexGroup = Flex.extend`
  aside {
    margin-bottom: 2em;
  }

  ${media.tablet`
    display: block;
  `};
`;

export const StyledHeading = styled(Heading)`
    margin-bottom: 1em !important;
`;

export const StyledList = styled.ul`
    list-style: none;
    margin-bottom: 0;
    padding-left: 0;
`;

export const ListHeading = styled.div`
    font-size: ${em(18)};
    color: ${colors.subtleText};
    padding-bottom: 0.5em;
    border-bottom: 1px solid ${colors.hairline};
    margin-bottom: 1.75em;

    & > span {
        font-size: ${em(34, 18)};
        font-weight: 500;
        color: ${colors.text};
    }
`;

export const StyledFilter = styled.div`
    & + & {
        margin-top: 1em;
    }

    ${media.tablet`
      &:last-child {
        margin-bottom: 4em;
      }
    `};

    @media print {
      & + & {
        margin-top: 0;
      }
    }
`;

export const FilterLabel = styled.span`
    font-size: ${em(14)};
    color: ${colors.subtleText};
    display: inline-block;
    margin-bottom: 0.25em;

    @media print {
      &:after {
        content: ":";
      }
    }
`;

export const DateRange = styled.div`
  display: flex;
  justify-content: space-between;

  & > * {
    display: block;
    flex: 1 0 calc(50% - 2px);

    &:first-child {
      margin-right: 4px;
    }

    ${media.tablet`
      &:first-child {
        margin-right: 0;
      }
    `};
  }
`;

export const VisibleOnDesktop = styled.div`
  ${media.tablet`
    display: none;
  `};
`;

export const VisibleOnTablet = styled.div`
  display: none;
  ${media.tablet`
    display: block;
    margin-top: 4em;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/styled.js